<template>
  <div class="card rose" style="width: 15em height: 40em">
    <div class="outer-image">
      <img :src="img" class="img-fluid" id="rose-image-catalog" />
    </div>
    <div class="card-body">
      <h5 class="card-title fs-4 fs-lg-2">{{ roseName }}</h5>
    </div>
    <div class="row justify-content-center rose-row" v-show="length != null">
      <div class="col-6 col-lg-3 mb-2 my-auto">
        <img
          src="../assets/icons/length.png"
          class="img-fluid"
          id="card-svg-l"
        />
      </div>
      <div class="col-6 col-lg-4 mb-2 my-auto fs-6">
        {{ length }}
      </div>
    </div>
    <div class="row justify-content-center rose-row" v-show="length != null">
      <div class="col-6 col-lg-3 mb-2 my-auto">
        <img src="../assets/icons/vaselife.png" id="card-svg-v" />
      </div>
      <div class="col-6 col-lg-4 mb-2 my-auto fs-6">
        {{ vaselife }}
      </div>
    </div>
    <div class="row justify-content-center rose-row" v-show="length != null">
      <div class="col-6 col-lg-3 mb-2 my-auto">
        <img src="../assets/icons/petals.png" id="card-svg-p" />
      </div>
      <div class="col-6 col-lg-4 mb-2 my-auto fs-6">
        {{ petals }}
      </div>
    </div>
    <div class="row justify-content-center rose-row" v-show="length != null">
      <div class="col-6 col-lg-3 mb-4 my-auto">
        <img src="../assets/icons/bloom.png" id="card-svg-b" />
      </div>
      <div class="col-6 col-lg-4 mb-4 my-auto fs-6">
        {{ bloom }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoseComponent",
  props: {
    roseName: String,
    length: String,
    vaselife: String,
    petals: String,
    bloom: String,
    img: String,
  },
};
</script>

<style>
.card.rose {
  background-color: transparent !important;
  border: none !important;
}

.list-group-item {
  border: none !important;
  background: transparent !important;
}

#card-svg-l {
  width: 1.2em;
}

#card-svg-v {
  width: 1.5em;
}

#card-svg-p {
  width: 2em;
}

#card-svg-b {
  width: 2.6em;
}

#rose-image-catalog {
  width: 10em;
  margin: auto !important;
  display: block !important;
}

.outer-image {
  background-image: url("../assets/catalog_rose_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  min-height: 13em;
  display: flex;
  justify-content: center;
}

@media only screen and (max-device-width: 812px) {
  #rose-image-catalog {
    width: 8em;
  }

  #rose-col {
    margin-bottom: 2em !important;
  }
}
</style>
